import React from 'react'
import './index.less'
import eyes_close from '../../../assets/images/eyes-close.png'
import eyes_open from '../../../assets/images/eyes-open.png'

class WealthManagementCard extends React.Component {
    render () {
        const { encryptionStatus, handleChangeEncryptionStatus } = this.props
        const { sublist = [] } = this.props.data
        return (
            <React.Fragment>
                {sublist.map((item) => {
                    return (
                        <div className="wealthManagementCardBox" key={item.id}>
                            <div className="wealthManagementCard_center">
                                <p className="card_title">总财富</p>
                                <div className="card_amount">
                                    <span className="card_amount_left">
                                        {encryptionStatus ? '****' : item.totalAmount}
                                    </span>
                                    <img
                                        src={encryptionStatus ? eyes_close : eyes_open}
                                        className="card_amount_right"
                                        onClick={() => {
                                            // this.setState({
                                            //   encryptionStatus: !this.state.encryptionStatus,
                                            // });
                                            handleChangeEncryptionStatus(!encryptionStatus)
                                        }}
                                    />
                                </div>
                                <div className="card_text">
                                    <span className="card_text_line">
                                      最新收益&ensp;{encryptionStatus ? '****' : item.newProfit}
                                    </span>
                                    <span className="card_text_line">
                                      累计收益&ensp;{encryptionStatus ? '****' : item.totalProfit}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </React.Fragment>
        )
    }
}
export default WealthManagementCard
